import ClaimsService from "@/api/services/claims";
import { toCamelCase } from "@estaly/ui";

const initialState = {
  index: [],
  totalPages: null,
  totalCount: null,
};

export default {
  namespaced: true,
  state: initialState,
  getters: {
    getIndex(state) {
      return state.index;
    },
    getTotalPages(state) {
      return state.totalPages;
    },
    getTotalCount(state) {
      return state.totalCount;
    },
    statusStyle: () => (status) => {
      const map = {
        to_collect_in_store: "bg-blue-100 text-blue-800",
        awaiting_shipment: "bg-yellow-100 text-yellow-800",
        in_transit: "bg-orange-100 text-orange-800",
        received_by_central_partner: "bg-gray-100 text-gray-800",
        valued: "bg-indigo-100 text-indigo-800",
        closed: "bg-green-100 text-green-800",
        cancelled: "bg-gray-100 text-gray-800",
      };
      return map[status] ?? "bg-gray-100 text-gray-800";
    },
    statuses: () => () => {
      return [
        "to_collect_in_store",
        "awaiting_shipment",
        "in_transit",
        "received_by_central_partner",
        "valued",
        "closed",
        "cancelled",
      ];
    },
    canUpdateStatus: () => (resource) => {
      return resource.status !== "closed" && resource.status !== "cancelled";
    },
  },
  mutations: {
    setIndex(state, data) {
      state.index = data.resources;
      state.totalCount = data.page.totalCount;
      state.totalPages = data.page.totalPages;
    },
  },
  actions: {
    async fetchIndex({ commit }, { page }) {
      const response = await ClaimsService.fetchUnfixeableClaimProducts({ page });
      if (!response?.success) return;

      const data = toCamelCase(response.data);
      commit("setIndex", data);
      return data;
    },

    async fetch(_, { id, ...params }) {
      const response = await ClaimsService.fetchUnfixeableClaimProduct(id, params);
      if (!response?.success) return;

      return toCamelCase(response.data);
    },

    async update(_, { id, data }) {
      const response = await ClaimsService.updateUnfixeableClaimProduct(id, data);
      if (!response?.success) return;

      return response;
    },
  },
};
